<a href="{{ link }}" target="{{ target }}">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  {{ text }}
</a>
